import moment from 'moment';

export const getGMTDate = (): string => {
  const date = new Date();
  return date.toUTCString();
};

export const getDate = (date: string): string => {
  if (!date) return date;
  const newDate = new Date(date);
  return newDate.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
};

export const getFullDate = (date: string): string => {
  if (!date) return date;
  const newDate = new Date(date);
  return moment(newDate).format('YYYY-MM-DD hh:mm A');
};

export const getEnUSDateTime = (): string => {
  return `${moment.utc().format('ddd MMM DD HH:mm:ss')} GMT ${moment.utc().year()}`;
};
